import { render, staticRenderFns } from "./ManualRetrieval.vue?vue&type=template&id=5b97cd2e&"
import script from "./ManualRetrieval.vue?vue&type=script&lang=js&"
export * from "./ManualRetrieval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports